import AnnualSummaryError from './AnnualSummaryError';
class AnnualSummaryCouponNotFound extends AnnualSummaryError {
    promotionalCouponId;
    constructor(promotionalCouponId, options) {
        super('Promotional coupon id not found', options);
        this.promotionalCouponId = promotionalCouponId;
    }
}
export default AnnualSummaryCouponNotFound;
